import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { path: '/', label: 'Dashboard', icon: '📊', roles: [] },
  { path: '/employees', label: 'Nhân viên', icon: '👥', roles: [] },
  { path: '/departments', label: 'Phòng ban', icon: '🏬', roles: [] },
  { path: '/positions', label: 'Chức danh', icon: '💼', roles: [] },
  { path: '/campaigns', label: 'Chiến dịch', icon: '🎯', roles: [] },
  { path: '/tasks', label: 'Đầu việc', icon: '📋', roles: [] },
  { path: '/attendance', label: 'Chấm công', icon: '⏱️', roles: [] },
  { path: '/leave', label: 'Nghỉ phép', icon: '📅', roles: [] },
  { path: '/payroll', label: 'Bảng lương', icon: '💰', roles: ['admin', 'hr_manager'] },
  { path: '/reports', label: 'Báo cáo', icon: '📈', roles: ['admin', 'hr_manager', 'manager', 'hr_staff'] },
  { path: '/users', label: 'Phân quyền', icon: '🔑', roles: ['admin'] },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  const visibleItems = navItems.filter(
    item => !item.roles.length || item.roles.includes(user?.role)
  );

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: "'Be Vietnam Pro', Inter, sans-serif", background: '#f0f4f8' }}>
      {/* Sidebar */}
      <aside style={{
        width: collapsed ? 64 : 240,
        background: 'linear-gradient(160deg, #1e3a8a 0%, #1e40af 100%)',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.2s',
        boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
        zIndex: 10,
        flexShrink: 0,
      }}>
        {/* Logo */}
        <div style={{ padding: '16px 14px 12px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          {collapsed ? (
            <img
              src="https://cole.vn/client_fe/v2/images/logo-white.png"
              alt="Cole"
              style={{ width: 36, height: 36, objectFit: 'contain' }}
            />
          ) : (
            <div>
              <img
                src="https://cole.vn/client_fe/v2/images/logo-white.png"
                alt="Cole HRM"
                style={{ height: 36, maxWidth: '100%', objectFit: 'contain', display: 'block' }}
              />
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', marginTop: 5, letterSpacing: '0.3px' }}>
                Quản lý nhân sự
              </div>
            </div>
          )}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '12px 0', overflowY: 'auto' }}>
          {visibleItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '10px 16px',
                color: isActive ? '#fff' : 'rgba(255,255,255,0.7)',
                background: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
                textDecoration: 'none',
                borderLeft: isActive ? '3px solid #38bdf8' : '3px solid transparent',
                fontSize: 14,
                fontWeight: isActive ? 600 : 400,
                transition: 'all 0.15s',
              })}
            >
              <span style={{ fontSize: 18, flexShrink: 0 }}>{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* User section */}
        <div style={{ padding: 16, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          {!collapsed && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>{user?.name}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>{user?.role}</div>
            </div>
          )}
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '8px 12px',
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: 6,
              color: '#fff',
              cursor: 'pointer',
              fontSize: 12,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              justifyContent: collapsed ? 'center' : 'flex-start',
            }}
          >
            <span>🚪</span>{!collapsed && 'Đăng xuất'}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <header style={{
          background: '#fff',
          padding: '12px 24px',
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          flexShrink: 0,
        }}>
          <button
            onClick={() => setCollapsed(!collapsed)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20 }}
          >
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'linear-gradient(135deg, #1e3a8a, #0891b2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontWeight: 700, fontSize: 14
            }}>
              {user?.name?.charAt(0)}
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>{user?.name}</div>
              <div style={{ fontSize: 11, color: '#64748b' }}>{user?.department_name}</div>
            </div>
          </div>
        </header>

        <div style={{ flex: 1, padding: '24px', overflow: 'auto' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
